import { render, staticRenderFns } from "./AssignClass.vue?vue&type=template&id=9e40fb5c&scoped=true&"
import script from "./AssignClass.vue?vue&type=script&lang=js&"
export * from "./AssignClass.vue?vue&type=script&lang=js&"
import style0 from "./AssignClass.vue?vue&type=style&index=0&id=9e40fb5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e40fb5c",
  null
  
)

export default component.exports